import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MutedOutlinedSvg from "@ant-design/icons-svg/es/asn/MutedOutlined";
import AntdIcon from "../components/AntdIcon";
var MutedOutlined = function MutedOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MutedOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MutedOutlined.displayName = 'MutedOutlined';
}
export default /*#__PURE__*/React.forwardRef(MutedOutlined);